import { render, staticRenderFns } from "./modalAlertContainer.vue?vue&type=template&id=52ab73a9&scoped=true&"
import script from "./modalAlertContainer.vue?vue&type=script&lang=js&"
export * from "./modalAlertContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52ab73a9",
  null
  
)

export default component.exports